import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

import EntityFilters from '../EntityFilters'
import EntityList from '../EntityList'

import ServiceProduct from './ServiceProduct/ServiceProduct'

interface ServiceProductsProps {
  assignTemplatePagePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
}

const ServiceProducts = (props: ServiceProductsProps) => {
  const { assignTemplatePagePermissionsPayload } = props

  return (
    <DashboardModule title="Products">
      <Box flexDirection="column" padding="large">
        <EntityFilters
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityName="Products"
        />

        <EntityList
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityKey="serviceProductIds"
          entityListItemComponent={ServiceProduct}
        />
      </Box>
    </DashboardModule>
  )
}

export default ServiceProducts
